import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiRequest } from '../utils/api';
import { ThemeToggle } from '../contexts/ThemeContext';

const VerifyEmailPage = () => {
  const [status, setStatus] = useState('verifying');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      apiRequest('auth/verify-email', {
        method: 'POST',
        body: { token }
      })
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setStatus('error');
    }
  }, [location]);

  return (
    <div className="relative min-h-[60vh] flex flex-col items-center justify-center bg-[var(--color-bg)] px-4 py-12">
      <div className="absolute top-4 right-4">
        <ThemeToggle compact />
      </div>
      <div className="text-center max-w-md">
        {status === 'verifying' && (
          <p className="text-[var(--color-text-secondary)]">Verifying your email...</p>
        )}
        {status === 'success' && (
          <div>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-2">Email Verified!</h2>
            <p className="text-[var(--color-text-secondary)] mb-6">
              Your email has been successfully verified. You can now log in.
            </p>
            <Link
              to="/login"
              className="inline-flex brand-gradient-btn px-6 py-2.5 rounded-lg font-semibold"
            >
              Go to login
            </Link>
          </div>
        )}
        {status === 'error' && (
          <div>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-2">Verification Failed</h2>
            <p className="text-[var(--color-text-secondary)] mb-6">
              Sorry, we could not verify your email. The link may be invalid or expired.
            </p>
            <Link
              to="/login"
              className="inline-flex text-[var(--color-primary)] hover:text-[var(--color-primary-hover)] font-medium"
            >
              Back to login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
